var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBoxColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.952,
    height: 16.98,
    viewBox: "0 0 16.952 16.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .checkBoxColored {\r\n        fill: #8c8d99;\r\n      }\r\n\r\n      .checkBoxColored2 {\r\n        fill: #1bc47d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18289",
    "data-name": "Group 18289",
    transform: "translate(-126.665 -287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Interface_Add",
    "data-name": "Outline / Interface / Add",
    transform: "translate(126.665 287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(-0.524 -0.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "checkBoxColored",
    d: "M8.476,16.98a42.257,42.257,0,0,1-4.683-.259,4.019,4.019,0,0,1-2.363-1.127A3.959,3.959,0,0,1,.277,13.242a40.885,40.885,0,0,1,0-9.5A3.96,3.96,0,0,1,1.431,1.386,4.015,4.015,0,0,1,3.794.259a42.436,42.436,0,0,1,9.366,0,4.014,4.014,0,0,1,2.362,1.127,3.963,3.963,0,0,1,1.154,2.352,40.985,40.985,0,0,1,0,9.5,3.962,3.962,0,0,1-1.154,2.352,4.018,4.018,0,0,1-2.362,1.127A42.275,42.275,0,0,1,8.476,16.98Zm0-15.48a40.778,40.778,0,0,0-4.516.25A2.5,2.5,0,0,0,1.767,3.913a39.47,39.47,0,0,0,0,9.154A2.5,2.5,0,0,0,3.96,15.231a40.778,40.778,0,0,0,4.516.25,40.8,40.8,0,0,0,4.517-.25,2.5,2.5,0,0,0,2.192-2.164,39.47,39.47,0,0,0,0-9.154A2.5,2.5,0,0,0,12.993,1.75,40.8,40.8,0,0,0,8.476,1.5Z",
    transform: "translate(0.524 0.51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(130.552 293.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-2",
    "data-name": "Check",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "checkBoxColored2",
    d: "M9.722.174a.594.594,0,0,1,0,.84L4.18,6.555a.594.594,0,0,1-.84,0L.174,3.389a.594.594,0,1,1,.84-.84L3.76,5.3,8.882.174A.594.594,0,0,1,9.722.174Z",
    transform: "translate(0 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxColored);
export default __webpack_public_path__ + "static/media/check-box-colored.36e4ebd220d4d9b3c92a0f65c2f18d9f.svg";
export { ForwardRef as ReactComponent };